/** In-app confirmation dialog, used instead of the browser's own confirm(). */
export function ConfirmDialog({
  open, title, body, confirmLabel, cancelLabel = "Cancel", tone = "default", onConfirm, onCancel,
}: {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel?: string;
  tone?: "default" | "danger";
  onConfirm: () => void;
  onCancel: () => void;
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
      onKeyDown={(e) => { if (e.key === "Escape") onCancel(); }}
    >
      <div className="w-full max-w-md rounded-lg border bg-background p-5 shadow-lg space-y-3">
        <h2 id="confirm-dialog-title" className="text-base font-semibold">{title}</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">{body}</p>
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" autoFocus onClick={onCancel} className="px-3 py-1.5 rounded-md border text-sm hover:bg-accent">
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-3 py-1.5 rounded-md text-sm font-medium ${
              tone === "danger" ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : "bg-primary text-primary-foreground hover:bg-primary/90"
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
